import {
  contextIsAvailable,
  extractTrackingPageContext,
} from '@aboutyou/legacy-shared/src/tracking/hooks/trackingHelpers'
import { OutfitDetailPageContext } from '@aboutyou/legacy-tracking-sdk'
import { exists } from 'helpers/exists'
import { useTracking } from 'helpers/tracking/hooks/useTrackingContextAndClientV6'
import { useTrackingCustomer } from 'helpers/tracking/trackerComponents/TrackCustomer'
import React, { FC, useEffect, useRef } from 'react'
import { useService } from 'services/utils/context'
import { useOdpStore } from 'store/context'

export function useTrackOutfitDetailPageView(pageTitle: string) {
  const { pageContext, TrackingClient } = useTracking()
  const service = useService()
  const lastTrackedIdRef = useRef<string | undefined>(undefined)
  const customer = useTrackingCustomer()

  const outfitId = useOdpStore(store => store.outfitId)
  const outfit = exists(outfitId) ? service.outfits.getById(outfitId) : null

  useEffect(() => {
    if (outfit && customer) {
      if (
        lastTrackedIdRef.current !== outfitId &&
        contextIsAvailable(pageContext) &&
        !pageContext.disabled
      ) {
        const page = extractTrackingPageContext(pageContext)
        lastTrackedIdRef.current = outfit.id
        TrackingClient?.trackOutfitView({
          page: { ...page, title: pageTitle } as OutfitDetailPageContext,
          customer,
        })
      }
    }
  }, [TrackingClient, outfit, outfitId, pageContext, pageTitle, customer?.type])
}

const TrackOutfitDetailPageView: FC<
  React.PropsWithChildren<{ pageTitle: string }>
> = ({ pageTitle, children }) => {
  useTrackOutfitDetailPageView(pageTitle)

  return <>{children}</>
}

export default TrackOutfitDetailPageView
